import { useTranslation } from 'language/translator'
import { useDashboardsInGroup } from 'redux/hooks/Dashboards'
import { useDashboardGroup } from 'redux/hooks/DashboardGroups'

export const isValidTitle = (title: string) => {
  return !/test|kopia|namnlös/i.test(title)
}

export const useChecklistItems = (dashboardGroupId: string) => {
  const { t } = useTranslation()

  const group = useDashboardGroup(dashboardGroupId)
  const dashboard = useDashboardsInGroup(dashboardGroupId)

  if (!group) {
    return []
  }

  return [
    {
      title: t('activity_overview', 'valid_dashboard_title'),
      body: t('activity_overview', 'valid_dashboard_title_helper'),
      value: isValidTitle(group.title)
    },
    {
      title: t('activity_overview', 'valid_tab_titles'),
      body: t('activity_overview', 'valid_tab_titles_helper'),
      value: dashboard.every((tab) => isValidTitle(tab.title))
    },
    {
      title: t('activity_overview', 'max_tabs'),
      body: t('activity_overview', 'max_tabs_helper'),
      value: dashboard.length <= 3
    },
    {
      title: t('activity_overview', 'max_widgets'),
      body: t('activity_overview', 'max_widgets_helper'),
      value: dashboard.every((tab) => tab.number_of_widgets <= 10)
    }
  ]
}
